var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "add_a_photo-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 98,
    viewBox: "0 0 95 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1637",
    "data-name": "Rectangle 1637",
    width: 95,
    height: 98,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M11.553,12.12V1h7.7V12.12H30.809v7.413H19.256v11.12h-7.7V19.533H0V12.12ZM23.107,34.36V23.24H34.66V12.12H61.619l7.048,7.413H80.874a7.584,7.584,0,0,1,7.7,7.413v44.48a7.584,7.584,0,0,1-7.7,7.413H19.256a7.584,7.584,0,0,1-7.7-7.413V34.36ZM50.065,67.72c10.629,0,19.256-8.3,19.256-18.533S60.694,30.653,50.065,30.653s-19.256,8.3-19.256,18.533S39.436,67.72,50.065,67.72ZM37.741,49.187A12.333,12.333,0,1,0,50.065,37.325,12.086,12.086,0,0,0,37.741,49.187Z",
    transform: "translate(0 5.503)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/image-upload.1da64168.svg";
export { ForwardRef as ReactComponent };